import { Params } from '@/common/api/fetcher'
import { filterBooleanToNumber, filterDefined } from '@/common/util/array'
import { isMatchedPartial } from '@/common/util/string'

export const makeParamsQueryStr = (params: Params) => {
  const filteredParam = filterBooleanToNumber(filterDefined(params))
  const searchParams = new URLSearchParams(filteredParam)
  const query = searchParams.toString()

  return query ? '?' + query : ''
}

export const replacePath = (path: string, params: Params) => {
  if (!params) {
    return { path, params }
  }

  let replacedPath: string = path
  let filteredParams: Params = {}
  for (const key in params) {
    const replaceKey = '{' + key + '}'
    if (isMatchedPartial(replacedPath, replaceKey)) {
      replacedPath = replacedPath.replace(replaceKey, params[key])
    } else {
      filteredParams[key] = params[key]
    }
  }

  return { path: replacedPath, params: filteredParams }
}

const paramsToStr = (path: string, params: Params): string => {
  const { path: replacedPath, params: filteredParams } = replacePath(path, params)

  if (Object.keys(filteredParams).length == 0) {
    return replacedPath
  }

  return replacedPath + makeParamsQueryStr(filteredParams)
}
